import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  p {\n    color: ",
        ";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px; /* 157.143% */\n    letter-spacing: -0.14px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Sizes } from "../icon/IconList";
import { ProductRating } from "../Reviews";
// 메인에서 혹은 검색페이지에서 사용되는 평점 컴포넌트입니다.
// 일단 시안상 통일된다면, 사이즈는 작게 가는게 좋을 것 같아서 스타일은 고정인데,
// 추가로 확장이 필요하다면 자유롭게 확장해주세요.
const RatingWithText = (param)=>{
    let { rating  } = param;
    return /*#__PURE__*/ _jsxs(AverageRating, {
        children: [
            /*#__PURE__*/ _jsx(ProductRating, {
                precision: 0.1,
                max: 1,
                value: rating,
                readOnly: true,
                size: Sizes.small
            }),
            /*#__PURE__*/ _jsx("p", {
                children: Number.isInteger(rating) ? "".concat(rating, ".0") : rating
            })
        ]
    });
};
//검색에서 사용되는 평점 컴포넌트
//스타일의 변경이 있어서 container를 새로 생성하였습니다.
export const SearchRatingWithText = (param)=>{
    let { rating  } = param;
    return /*#__PURE__*/ _jsxs(SearchAverageRating, {
        children: [
            /*#__PURE__*/ _jsx(ProductRating, {
                precision: 0.1,
                max: 1,
                value: rating,
                readOnly: true,
                size: Sizes.small
            }),
            /*#__PURE__*/ _jsx("p", {
                children: Number.isInteger(rating) ? "".concat(rating, ".0") : rating
            })
        ]
    });
};
const SearchAverageRating = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        p: {
            color: theme.palette.text.secondary,
            ...theme.typography.body2
        }
    };
});
const AverageRating = styled.div.withConfig({
    componentId: "sc-a59a8c42-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_700);
export default RatingWithText;
